module.exports = __webpack_public_path__ + "img/4.43cd8eb4.png";